import { useEffect, useState } from "react";

const MenuItem = ({ item, nested = 0, isMobile }) => {
	const [isSubmenuOpen, setIsSubmenuOpen] = useState(false || !isMobile);

	// desktop hide sub-menus except for current season
	const showChildrenMobile = isMobile && item.children && Object.keys(item.children).length && nested < 1;
	const showChildrenDesktop = !isMobile && item.children && item.children.length;

	const styles = {
		paddingLeft: `${nested * 3}rem`,
	};

	useEffect(() => {
		if (isMobile) {
			setIsSubmenuOpen(false);
		}
		else {
			setIsSubmenuOpen(true);
		}
	}, [isMobile]);


	const loopSelf = () => {
		/* recursive function to check if each item has children */
		if (!showChildrenMobile && !showChildrenDesktop || !isSubmenuOpen) return null;

		return (
			<ul className="menu__list">
				{Object.values(item.children).map((child) => {
					return <MenuItem item={child} key={child.id} nested={nested + 1} />;
				})}
			</ul>
		)
	};

	const handleClick = () => {
		setIsSubmenuOpen(!isSubmenuOpen);
	};

	const showButton = !!showChildrenMobile && isMobile;

	return (
		<>
			<li className={`menu__item ${showChildrenMobile ? "has-children" : ""}`} key={item.title}>
				<a href={item.url} dangerouslySetInnerHTML={{ __html: item.title }} style={styles} />
				{showButton && <button className={`menu__item__button ${isSubmenuOpen ? "open" : ""}`} aria-label={`expand navigation ${item.title} sub-menu`} onClick={handleClick}></button>}
			</li>
			
			{loopSelf()}
		</>
	);
};

export default MenuItem;
